import { LoadingSpinner } from 'components/LoadingSpinner';

export function FullscreenLoadingSpinner() {
  return (
    <div role="progressbar" className="fixed inset-0 flex items-center justify-center z-50 bg-white bg-opacity-60">
      <LoadingSpinner />
    </div>
  );
}
